import { type RefObject, useEffect } from 'react';

export type WebComponentEvent = {
    eventName: string;
    eventCallback: () => void;
};

export function useWebComponentEvents(ref: RefObject<HTMLElement | null>, isReady: boolean, events: WebComponentEvent[]) {
    useEffect(() => {
        const refElement = ref.current;
        if (!refElement || !isReady) return;

        events.forEach(({ eventName, eventCallback }) => {
            refElement.addEventListener(eventName, eventCallback);
        });

        return () => {
            events.forEach(({ eventName, eventCallback }) => {
                refElement.removeEventListener(eventName, eventCallback);
            });
        };
    }, [isReady, events, ref]);
}
